import { useLoaderData } from 'react-router';

import { useInvoiceTemplate } from '~/api/invoiceTemplates';
import { Redirect } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

import type { loader } from './EditInvoiceTemplate.loader';

import { CreateEditInvoiceTemplateForm } from './CreateEditInvoiceTemplateForm';

export const EditInvoiceTemplate = () => {
  const loaderData = useLoaderData<typeof loader>();
  const { data: invoiceTemplate } = useInvoiceTemplate(loaderData.id);

  if (!invoiceTemplate) {
    return <Redirect to={routes.invoiceTemplates} />;
  }

  return <CreateEditInvoiceTemplateForm invoiceTemplate={invoiceTemplate} mode="edit" />;
};
